import React from "react";
import Logo from "../../assets/logo.png";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="bg-green-100">
            <div className="py-3 pb-6 px-5 text-white gap-6 md:gap-4 h-fit flex flex-col justify-start items-center md:items-start max-w-7xl mx-auto">
                <div className="flex flex-col items-center gap-1 p-4 md:flex-row md:gap-4">
                    <div className="flex flex-row items-center justify-center gap-2">
                        <img className="w-8" src={Logo} alt="logo" />
                        <h2 className="text-2xl font-bold text-green-main text-nowrap">Natur Med</h2>
                    </div>
                    <p className="text-sm text-gray-800 font-bold md:text-lg">Gabinet Terapii Naturalnych</p>
                </div>
                <ul className="py-2 w-full flex flex-col justify-center items-center gap-5 text-gray-800 text-sm md:flex-row md:justify-between md:items-start">
                    <li>
                        <h4 className="font-bold text-lg md:text-xl"><Link to="/about-us">O nas</Link></h4>
                    </li>
                    <li>
                        <h2 className="font-bold text-lg md:text-xl text-center md:text-left"><Link to="/contact">Kontakt</Link></h2>
                        <p>+48 503 603 723</p>
                        <p>mail@example.com</p> {/*TODO*/}
                        <p>ul. Jana III Sobieskiego 39</p>
                        <p>32-650 Kęty</p>
                    </li>
                    <li>
                        <h4 className="font-bold text-lg md:text-xl text-center md:text-left">Godziny otwarcia</h4>
                        <p>Poniedziałek - Piątek: 8:00 - 17:00</p>
                    </li>
                </ul>
                <div className="w-full pt-4">
                    <p className="text-xs text-center md:text-left text-gray-800">Copyright @ 2024 naturmed.pro All rights reserved</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;